<h2 mat-dialog-title>Search for contacts</h2>
<div mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
  <div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
    <app-grid-filter
      placeholder="Type '/' to bring up a list of available filters, or type a number, name, tag to filter"
      [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    </app-grid-filter>
    <div fxFlex="auto" fxFlexFill class="stretched-container">
      <app-dialog-contacts-grid #grid [filterChangeEvent]="filterChangeEvent"></app-dialog-contacts-grid>
    </div>
  </div>
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
  <button mat-raised-button color="primary" [disabled]="grid.selectedRows.isEmpty()" (click)="selectContact(grid.selectedRows)">Select</button>
  <button mat-button [mat-dialog-close]="false">Close</button>
</div>
